import {applyMiddleware, createStore} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly';
import createSagaMiddleware from 'redux-saga';
import get from 'lodash/get';
import throttle from 'lodash/throttle';
import reducers from './reducers';
import sagas from './sagas';

const LOCAL_STORAGE_SETTINGS_KEY = 'neosvoc:settings';

const sagaMiddleware = createSagaMiddleware();

const preloadedState = {};
try {
    const serializedSettings = localStorage.getItem(LOCAL_STORAGE_SETTINGS_KEY);
    if (serializedSettings) {
        preloadedState.settings = JSON.parse(serializedSettings);
    }
} catch (err) {} // eslint-disable-line no-empty

const saveState = (state) => {
    try {
        const settings = get(state, 'settings');
        if (settings) {
            localStorage.setItem(LOCAL_STORAGE_SETTINGS_KEY, JSON.stringify(settings));
        }
    } catch (err) {} // eslint-disable-line no-empty
};

const composeEnhancers = composeWithDevTools({
    // Specify name here, actionsBlacklist, actionsCreators and other options if needed
});
const store = createStore(
    reducers,
    preloadedState,
    composeEnhancers(applyMiddleware(sagaMiddleware)),
);

store.subscribe(throttle(() => saveState(store.getState()), 1000));

sagaMiddleware.run(sagas);

export default store;
